import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState } from 'react';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LinearProgress from '@mui/material/LinearProgress';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import TextField from '@mui/material/TextField';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {clearCustomerPortalUserId, copyLeftItemsToRight, copyRightItemsToLeft, fetchCoatings, fetchExtraServices, fetchLensBrands, fetchLensDesignTypes, fetchLensIndexes,  fetchLensMaterialTypes,  fetchLensTypes,fetchProduct,fetchProducts,getRXOrderPreview,initialRXOrder,resetRXOrderResultBox,setCustomerPortalUserId,setRXOrderCoatings,setRXOrderConsumer,setRXOrderDateMustDelivered,setRXOrderDescription,setRXOrderPayType,setRXOrderResultBox,setRXOrderSelectedBase,setRXOrderSelectedBVD,setRXOrderSelectedCoating,setRXOrderSelectedColor,setRXOrderSelectedColoringType,setRXOrderSelectedColorRate,setRXOrderSelectedColorRateBottom,setRXOrderSelectedColorRateTop,setRXOrderSelectedCorridor,setRXOrderSelectedDBL,setRXOrderSelectedED,setRXOrderSelectedEmergencyLevel,setRXOrderSelectedExtraServices,setRXOrderSelectedFFA,setRXOrderSelectedFITTINGL,setRXOrderSelectedFITTINGR,setRXOrderSelectedFrameType,setRXOrderSelectedHBOX,setRXOrderSelectedIPDL,setRXOrderSelectedIPDR,setRXOrderSelectedLAdd,setRXOrderSelectedLAxis,setRXOrderSelectedLBaseOfPrism,setRXOrderSelectedLCYL,setRXOrderSelectedLCYLSign,setRXOrderSelectedLDC,setRXOrderSelectedLDia,setRXOrderSelectedLensBrand,setRXOrderSelectedLensDesignType,setRXOrderSelectedLensIndex, setRXOrderSelectedLensMaterialType, setRXOrderSelectedLensType, setRXOrderSelectedLPosition, setRXOrderSelectedLPrism, setRXOrderSelectedLSPH, setRXOrderSelectedLSPHSign, setRXOrderSelectedOldLens, setRXOrderSelectedPANTO, setRXOrderSelectedProduct, setRXOrderSelectedQuantity, setRXOrderSelectedRAdd, setRXOrderSelectedRAxis, setRXOrderSelectedRBaseOfPrism, setRXOrderSelectedRCYL, setRXOrderSelectedRCYLSign, setRXOrderSelectedRDC, setRXOrderSelectedRDia, setRXOrderSelectedRPosition, setRXOrderSelectedRPrism, setRXOrderSelectedRSPH, setRXOrderSelectedRSPHSign, setRXOrderSelectedVBOX, setRXOrderStoreName, submitRXOrder, toggleRXOrderLeftEyeAccordion, toggleRXOrderRightEyeAccordion, updateRXOrderADDValues } from '../slices/rxorder.slice'
import Autocomplete from '@mui/material/Autocomplete';
import { addComma, GetAddState, GetCorridorState, IsColoringTypeValid, IsLeftAddValid, IsRightAddValid, IsRXOrderValidForPreview, removeComma, separateNumber, ValidateRXOrder } from '../helpers/mmg';
import Switch from '@mui/material/Switch';
import SubdirectoryArrowLeftIcon from '@mui/icons-material/SubdirectoryArrowLeft';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import DatePicker from "react-multi-date-picker";
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import { FormGroup,FormLabel,FormControl } from '@mui/material';
import RXPreviewItems from './RXPreviewItems';
import { useForm, Controller } from 'react-hook-form'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Divider from '@mui/material/Divider';
import left from '../assets/images/left.jpg'
import right from '../assets/images/right.jpg'
import ron from '../assets/images/logos/ron.png'
import lon from '../assets/images/logos/lon.png'
import framesize from '../assets/images/framesize.png'
import colorandservice from '../assets/images/colorandservice.png'
import leftrighteye from '../assets/images/leftrighteye.png'
import productbrand from '../assets/images/productbrand.png'
import customericon from '../assets/images/customericon.png'
import CancelIcon from '@mui/icons-material/Cancel';
import { Stack } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import {DebounceInput} from 'react-debounce-input';


export const zeroPad = (num, places) => String(num).padStart(places, '0');

const PositiveNegativeSwitch = styled(Switch)(({ theme }) => ({
  width: 54,
  height: 28,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    margin: 0,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE0ElEQVR4nO2ZS1NaZxjHz5jaUUSuAuJBIG2+QaedZJUpykW5iUpQ8ILo+BXacXNGUQ94Q4WoqEm03iKgmUmbbrrutNNd02S6bYzTRQ1ZSzZP5zmZZiEgnIu0nfE/8w7b3/89z+19IIhrXeta/JXy3jCkQncMh8Ex/eHQUfPB4Ev9QfCt7mDgnW6//x25N/CW3Ol7odvpOyJ3AmPkTuA2QVFVxL+tT58Emw2p4YgxHTo1pIbAcDgE+sdB0B8EoflgEJr3B0C3NwC63X7mkDt9QH4TgKbtAGi3el83bvlpcj2gqzj4rdSQypAOJQ3p4ZwxHQK28E3bftBu+UH7qBc0D3pymoe+VW2yt6Ei8J9khv3GTChrTA8DX/jGhz3vzwMfqDd8bzTJez1XBv5ZcrTamBnZMGYQXFh4zaYPNBv3QL3hBdW6d41IjlYLCq99Oiq6mRn+/qrh1eteUCW7QbXW/UybdIgEu/kKw4NqrQsaVj0/ECnvx7wNVCJs1HnwndCw0gmKhGeVF/zNo5EAJ/hHfmhc8UJjogs08S7QJLqgcdPHCl553wPKhAfky24fJ/im436lIRM643LzCP/Ln7/DP/r59CWo452s4RWJDlDEXVnxnIN9icU6zzVs8OYvSr3UwQHejV8A5Euu+6zgbx2N6Pg0KQybi1ItdnCFB/mSMydfdOjLv/334wHnhNXEO/MNxNwc4V0gW3SCNGany6OnqCpDaug1n2qjXvbkGWiIuTjDy2IOkCw4TnFoLOP2Q3f4lsqCBhZcnOGlC3jsIJm3f1HawGFwjG+dx4S9KOW8ky88SObavy5pQP84eMy3SWHC5hmYc/KFh/qZtnQ5Bl6walLxTiZkmLPUwcCr5l35BmbsoJh1MEc+Ywd51A6yaDvIIm0gpduYX3nMWRx+tg3qZ2zPSxvYH8yyaVJC6adXv4GUthWHxxO1npU0oNsfzLFtUkJJEjYXh5+xgThiPS9tYG8gx7ZJCWZgwlwcPmoDMW0pbYDc7c9e2qQSXcxsI7R+/OM5SKYsxeEjVhDRltIhxGwPLqs2mz5mMPuQsDE306SwzmOpxGqDCXtRsmkbyGgbSKdtIJ2yMkcyaWHCBm+egZ9tLwpfF7GAaNpSOonJ3b5jvvO8YraAAdpWXqmcLQxfR6OB1tJllNnb8HyMKAp8Abx5fvBmEE22flWOgdt8X1LyaHu+gSkrP/gpM9SOt3xe1jCn3fafcIXHDiuPFDbACz7c+qrsbR5uzLjC43iAXfWiMGE5w0+2Qm3YNF0WPBNG6wEdbsy4wONsgwnLuklFL4U/r500kQQb4bqP2xvWzSQs6yYVKQI/2QI14ZY4wVa6Da9CvXnvjMszEEMIZxs2TaquGPyE6Y2Yusttb4q7Sk7PwJiTGczYNKm6AvC14RaoHTd5CT7CXaUALylO8DXjXyYI3kp5bzSsdj+pOPyE6TuCuvuRMMvdpEOkXPE8q+DNf0tQAi13Pyg5Wo27yoqEDSXQzRcS7ioVy+4zoeFrJkx/8U7YclUf71Diuk++6DrnDR82nWOdl1AWBVFpKebtJG7MJAv2E/bwLSc4HrDusFciiqrCpRPubXD1gdsDcdSWFUetOXHEkhPR5qyINv+K8zyOxMxU+V/4m/Va1yL+//obWqk80KDREHgAAAAASUVORK5CYII=')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#AED581' : '#AED581',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? '#00ff00' : '#00ff00',
    width: 28,
    height: 28,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACXklEQVR4nO1Zy27UQBAcQS7ceJx4/AOH3a61UCSjHgvuiCC+hEA4cAlwJQLEPwBBKPkSED8A5AAkQMi0heFi1NYSXhvZ69fYyCW1tPJq11Wenu7psjEDBgyojPSWORRHCISxIox1sXgllj45i+8a+jm7xvRULG7E5ycT/Y3xjTjEGce46yxtiUU6TzhLbx3TnZiD060T/2LphLN45Bjf5iX+jxBGIoyHuxeC462Qdzy5KoydqsRnxLaL6EpjxNMwXNCn3gDx9M+gB3qveskHwRHH2GyePKb7Axt6z3rILy0ddhbP2iIvv/bGZi0r0U7a4KB0ul99w3ojjyz2GJdLkdeyppXBtwBh7GjZ7lnqoFoqTTts5SZVVzhGMlfH1uOBb9LytwhLtwuR10OWY7zpoIAtLen56aOnyg4QlhkR8wi5AoTppm+iclAwLefnv4euK4WDnuSvQDaM5P9Z3ZBiK/CySAp97KwAi+38FCpY/30IcIzk/xcgfU8h6f8mxno7JbFUPC4iYKUDRNPZK4BruQLUdPJO1M6OOKJxfw9zjNeF3Tx1zDonwGK1EPnfBpqkQ08/iaNzp8w8ULvPN3H5GYw1U2qoZ3zwT57e7y4uHjNloF6lbwF70fiSqQL1Kv0JoHumKnQO9dGdXV3W4r65a7HRHnl6Xpu5uy8iDBfUYGpcAGOtkPtQFupVamVoIN/fVd6wRaFlTVejjmbnLH3Vp/45PHvUtA3tjuqYlTk76dnGWazKxdFJ04nXrDyCRHRdrQ8dPHSy0/E0G1GzKY9eTL9bju2YOvGadcAA03/8AJ3V/nk1KoorAAAAAElFTkSuQmCC')`,
    
    }
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#FFCCBC' : '#FFCCBC',
    borderRadius: 20 / 2,
  },
}));


export const RX = () => {
  const [open, setOpen] = React.useState(false);

  const { register, handleSubmit, control, formState: { errors }} = useForm();



  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);  
  const authUser = JSON.parse(localStorage.getItem('user'))

  const rxOrder = useSelector(x => x.rxOrder);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));
  const barcodeItemRef = useRef();
  let navigate = useNavigate();
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'right',
    //color: theme.palette.text.secondary,
  }));



   useEffect(() => {

    dispatch(initialRXOrder());
    dispatch(fetchLensBrands({authUser}));
    dispatch(fetchExtraServices({authUser}));

    if(rxOrder.customerPortalUserId !== undefined && rxOrder.customerPortalUserId !== null && rxOrder.customerPortalUserId !== "")
    {
      dispatch(setCustomerPortalUserId(rxOrder.customerPortalUserId));
    }
    else if(authUser.underControlUsers !== undefined && authUser.underControlUsers !== null && authUser.underControlUsers.length > 0){
      dispatch(setCustomerPortalUserId(authUser.underControlUsers[0].Value));
    }
    
    if(authUser.role === "Optician" && authUser.underControlUsers !== undefined && authUser.underControlUsers !== null && authUser.underControlUsers.length > 0 ){
      //اگر کاربر غیر از عینک ساز نهایی بود 
      var theStoreName = authUser.underControlUsers[0].Description ;
      console.log(theStoreName);
      dispatch(setRXOrderStoreName(theStoreName));
    }
    
    //dispatch(fetchDefaultValues({authUser}));

   }, []);


   const handleCloseMessageBox = () =>{
    dispatch(resetRXOrderResultBox());
    //navigate('/RX');
  }
  const handleCloseMessageBoxAndGotoOrderList = () =>{
    dispatch(resetRXOrderResultBox());
    navigate('/Orders');
  }
  

   const mdTheme = createTheme({

    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
  });

//#region محصول
const handleLensBrandChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setRXOrderSelectedLensBrand(0));

  }else{
    dispatch(setRXOrderSelectedLensBrand(value.id));
    dispatch(fetchLensTypes({selectedLensBrandId: value.id, authUser}));
    dispatch(fetchCoatings({selectedLensBrandId: value.id , selectedLensMaterialTypeValue : '', selectedDesignTypeValue : '' , defaultCoatingId : null , authUser}));
  }
}
const handleLensTypeChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setRXOrderSelectedLensType(0));
  }else{
    dispatch(setRXOrderSelectedLensType(value.id));
    dispatch(fetchLensDesignTypes({ selectedLensBrandId: rxOrder.selectedLensBrandId, selectedLensTypeId : value.id, authUser}));
  }
  
}
const handleLensDesignTypeChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setRXOrderSelectedLensDesignType(0));
  }else{
    dispatch(setRXOrderSelectedLensDesignType(value.id));
    dispatch(fetchLensIndexes({ selectedLensBrandId: rxOrder.selectedLensBrandId, selectedLensTypeId : rxOrder.selectedLensTypeId , selectedLensDesignTypeId : value.id, authUser}));
    dispatch(fetchCoatings({selectedLensBrandId: rxOrder.selectedLensBrandId , selectedLensMaterialTypeValue : '' , selectedDesignTypeValue : (rxOrder.lensDesignTypes.length > 0 ? rxOrder.lensDesignTypes.find(r => r.Value.toString() === value.id.toString()).Name : '') , defaultCoatingId : null , authUser}));
    dispatch(updateRXOrderADDValues());


  }
  
}
const handleLensIndexChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setRXOrderSelectedLensIndex(0));
  }else{
    dispatch(setRXOrderSelectedLensIndex(value.id));
    dispatch(fetchLensMaterialTypes({ selectedLensBrandId: rxOrder.selectedLensBrandId, selectedLensTypeId : rxOrder.selectedLensTypeId, selectedLensDesignTypeId : rxOrder.selectedLensDesignTypeId , selectedLensIndexId : value.id , authUser}));
  }
}

const handleLensMaterialTypeChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setRXOrderSelectedLensMaterialType(0));
  }else{
    dispatch(setRXOrderSelectedLensMaterialType(value.id));
    dispatch(fetchProducts({ selectedLensBrandId: rxOrder.selectedLensBrandId, selectedLensTypeId : rxOrder.selectedLensTypeId, selectedLensDesignTypeId : rxOrder.selectedLensDesignTypeId , selectedLensIndexId : rxOrder.selectedLensIndexId , selectedLensMaterialTypeId : value.id , authUser}));
    dispatch(fetchCoatings({selectedLensBrandId: rxOrder.selectedLensBrandId , selectedLensMaterialTypeValue : (rxOrder.lensMaterialTypes.length > 0 ? rxOrder.lensMaterialTypes.find(r => r.Value.toString() === value.id.toString()).Name : '') , selectedDesignTypeValue : (rxOrder.lensDesignTypes.length > 0 ? rxOrder.lensDesignTypes.find(r => r.Value.toString() === rxOrder.selectedLensDesignTypeId.toString()).Name : '') , defaultCoatingId : null , authUser}));

  }
}
const handleProductChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedProduct(null));
  }else{

    if (rxOrder.products.find(r => r.Value === value.id.toString())) {
      var selectedProduct = rxOrder.products.find(r => r.Value === value.id.toString());
      dispatch(setRXOrderSelectedProduct({selectedProductId : selectedProduct.Value , selectedProductCode : selectedProduct.Code, selectedProductTitle : selectedProduct.Name , selectedFee : selectedProduct.Fee , authUser }));
  
    }
      //dispatch(fetchProducts({selectedLensBrandId: rxOrder.selectedLensBrandId, selectedLensTypeId : rxOrder.selectedLensTypeId, selectedLensIndexId : rxOrder.selectedLensIndexId, selectedLensSphid : rxOrder.selectedLensSphId , selectedCylId : value.id, authUser}));
  }
}

const handleCoatingChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedCoating(null));
  }else{

    dispatch(setRXOrderSelectedCoating(value.id));
    
      //dispatch(fetchProducts({selectedLensBrandId: rxOrder.selectedLensBrandId, selectedLensTypeId : rxOrder.selectedLensTypeId, selectedLensIndexId : rxOrder.selectedLensIndexId, selectedLensSphid : rxOrder.selectedLensSphId , selectedCylId : value.id, authUser}));
  }
}

const handleCorridorChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedCorridor(null));
  }else{
    dispatch(setRXOrderSelectedCorridor(value.id));
  }
}
 //#endregion

 //#region ابعاد فریم
 const handleHBOXChange = (e) => {

  console.log(e);


  if(e.target.value === null){
    dispatch(setRXOrderSelectedHBOX(null));
  }else{
    dispatch(setRXOrderSelectedHBOX(e.target.value));
  }
}
const handleVBOXChange = (e) => {

  //console.log(e);


  if(e.target.value === null){
    dispatch(setRXOrderSelectedVBOX(null));
  }else{
    dispatch(setRXOrderSelectedVBOX(e.target.value));
  }
}
const handleBASEChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setRXOrderSelectedBase(null));

  }else{
    dispatch(setRXOrderSelectedBase(value.id));
  }
}
const handleFrameTypeChange = (event, value) =>{

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setRXOrderSelectedFrameType(null));

  }else{
    dispatch(setRXOrderSelectedFrameType(value.id));
  }
}
const handleFITTINGLChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedFITTINGL(null));
  }else{
    dispatch(setRXOrderSelectedFITTINGL(e.target.value));
  }
}
const handleFITTINGRChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedFITTINGR(null));
  }else{
    dispatch(setRXOrderSelectedFITTINGR(e.target.value));
  }
}
const handleIPDLChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedIPDL(null));
  }else{
    dispatch(setRXOrderSelectedIPDL(e.target.value));
  }
}
const handleIPDRChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedIPDR(null));
  }else{
    dispatch(setRXOrderSelectedIPDR(e.target.value));
  }
}
const handleDBLChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedDBL(null));
  }else{
    dispatch(setRXOrderSelectedDBL(e.target.value));
  }
}
const handleEDChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedED(null));
  }else{
    dispatch(setRXOrderSelectedED(e.target.value));
  }
}
const handlePANTOChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedPANTO(null));
  }else{
    dispatch(setRXOrderSelectedPANTO(e.target.value));
  }
}
const handleFFAChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedFFA(null));
  }else{
    dispatch(setRXOrderSelectedFFA(e.target.value));
  }
}
const handleBVDChange = (e) => {

  //console.log(e);

  if(e.target.value === null){
    dispatch(setRXOrderSelectedBVD(null));
  }else{
    dispatch(setRXOrderSelectedBVD(e.target.value));
  }
}
 //#endregion

//#region چشم راست 
const onRightEyeAccordionChanged = (e) =>{

  dispatch(toggleRXOrderRightEyeAccordion());

}
const handleCustomerPortalUserChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(clearCustomerPortalUserId(null));
  }else{
    dispatch(setCustomerPortalUserId(value.id.toString()));

    //if(authUser.role !== "Optician"){
      //اگر کاربر غیر از عینک ساز نهایی بود 
      console.log(value.id.toString());
      var theStoreName = value.id !== undefined && value.id !== null && value.id !== "" ? authUser.underControlUsers.find(r => r.Value == value.id.toString()).Description : ''
      console.log(theStoreName);
      dispatch(setRXOrderStoreName(theStoreName));
   // }
    
  }
  
}

const handleRSPHSign = (e) =>{

  
  dispatch(setRXOrderSelectedRSPHSign(e.target.checked ? "true" : "false"));

}
const handleRSPHChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedRSPH(null));
    dispatch(setRXOrderSelectedFITTINGR(null));
    dispatch(setRXOrderSelectedIPDR(null));
  }else{
    dispatch(setRXOrderSelectedRSPH(value.id));
  }
}
const handleRCYLSign = (e) =>{

  
  dispatch(setRXOrderSelectedRCYLSign(e.target.checked ? "true" : "false"));

}
const handleRCYLChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedRCYL(null));
  }else{
    dispatch(setRXOrderSelectedRCYL(value.id));
  }
}

const handleRAXISChange = (event, value) => {

  console.log(event);
  console.log(value);
  if(value === null){
    dispatch(setRXOrderSelectedRAxis(null));
  }else{
    dispatch(setRXOrderSelectedRAxis(value.id));
  }

}

const handleRAddChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedRAdd(null));
  }else{
    dispatch(setRXOrderSelectedRAdd(value.id));
  }
}
const handleRDiaChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedRDia(null));
  }else{
    dispatch(setRXOrderSelectedRDia(value.id));

    dispatch(setRXOrderSelectedHBOX(null));
    dispatch(setRXOrderSelectedVBOX(null));
    dispatch(setRXOrderSelectedDBL(null));
    dispatch(setRXOrderSelectedED(null));
  }
}
const handleRDCChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedRDC(null));
  }else{
    dispatch(setRXOrderSelectedRDC(value.id));
  }
}
const handleRPositionChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedRPosition(null));
  }else{
    dispatch(setRXOrderSelectedRPosition(value.id));
  }
}

const handleRPrismChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedRPrism(null));
  }else{
    dispatch(setRXOrderSelectedRPrism(value.id));
  }
}
const handleRBaseOfPrismChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedRBaseOfPrism(null));
  }else{
    dispatch(setRXOrderSelectedRBaseOfPrism(value.id));
  }
}
 //#endregion

//#region چشم چپ 
const onLeftEyeAccordionChanged = (e) =>{

  dispatch(toggleRXOrderLeftEyeAccordion());

}
const handleLSPHSign = (e) =>{

  
  dispatch(setRXOrderSelectedLSPHSign(e.target.checked ? "true" : "false"));

}
const handleLSPHChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedLSPH(null));
    dispatch(setRXOrderSelectedFITTINGL(null));
    dispatch(setRXOrderSelectedIPDL(null));
  }else{
    dispatch(setRXOrderSelectedLSPH(value.id));
  }
}
const handleLCYLSign = (e) =>{

  
  dispatch(setRXOrderSelectedLCYLSign(e.target.checked ? "true" : "false"));

}
const handleLCYLChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedLCYL(null));
  }else{
    dispatch(setRXOrderSelectedLCYL(value.id));
  }
}
const handleLAXISChange = (event, value) => {


    
  console.log(event);
  console.log(value);

    if(value === null){
      dispatch(setRXOrderSelectedLAxis(null));
    }else{
      dispatch(setRXOrderSelectedLAxis(value.id));
    }
  
  
}
const handleLAddChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedLAdd(null));
  }else{
    dispatch(setRXOrderSelectedLAdd(value.id));
  }
}
const handleLDiaChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedLDia(null));
  }else{
    dispatch(setRXOrderSelectedLDia(value.id));

    dispatch(setRXOrderSelectedHBOX(null));
    dispatch(setRXOrderSelectedVBOX(null));
    dispatch(setRXOrderSelectedDBL(null));
    dispatch(setRXOrderSelectedED(null));
    
  }
}
const handleLDCChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedLDC(null));
  }else{
    dispatch(setRXOrderSelectedLDC(value.id));
  }
}
const handleLPositionChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedLPosition(null));
  }else{
    dispatch(setRXOrderSelectedLPosition(value.id));
  }
}
const handleEmergencyLevelChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedEmergencyLevel(null));
  }else{
    dispatch(setRXOrderSelectedEmergencyLevel(value.id));
  }
}


const handleLPrismChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedLPrism(null));
  }else{
    dispatch(setRXOrderSelectedLPrism(value.id));
  }
}
const handleLBaseOfPrismChange = (event, value) => {


  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedLBaseOfPrism(null));
  }else{
    dispatch(setRXOrderSelectedLBaseOfPrism(value.id));
  }
}
 //#endregion

//#region ‌رنگ و خدمات

const handleLColoringTypeChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedColoringType(null));
    dispatch(setRXOrderSelectedColorRateTop(null));
    dispatch(setRXOrderSelectedColorRateBottom(null));
    dispatch(setRXOrderSelectedColorRate(null));
    dispatch(setRXOrderSelectedColor(null));

  }else{
    dispatch(setRXOrderSelectedColoringType(value.id));
  }
}
const handleLColorChange = (event, value) => {

  console.log(event);
  console.log(value);

  if(value === null){
    dispatch(setRXOrderSelectedColor(null));

  }else{
    dispatch(setRXOrderSelectedColor(value.id));
  }
}
const handleColoingRateChange = (e) => {

  console.log(e);
  if(e.target.value === null){
    dispatch(setRXOrderSelectedColorRate(null));
  }else{
    dispatch(setRXOrderSelectedColorRate(e.target.value));
  }
}
const handleColoingRateTopChange = (e) => {

  console.log(e);
  if(e.target.value === null){
    dispatch(setRXOrderSelectedColorRateTop(null));
  }else{
    dispatch(setRXOrderSelectedColorRateTop(e.target.value));
  }
}
const handleColoingRateBottomChange = (e) => {

  console.log(e);
  if(e.target.value === null){
    dispatch(setRXOrderSelectedColorRateBottom(null));
  }else{
    dispatch(setRXOrderSelectedColorRateBottom(e.target.value));
  }
}
const handleExtraServiceHandler = (e, values) => {

  console.log(values);
  dispatch(setRXOrderSelectedExtraServices(values));
  //if(e.target.value === null){
  //  dispatch(setRXOrderSelectedColorRateBottom(null));
  //}else{
  //  dispatch(setRXOrderSelectedColorRateBottom(e.target.value));
  //}
}
const handleOldLensChange = (e) => {

  console.log(e.target.value);
  //dispatch(setRXOrderSelectedExtraServices(values));
  if(e.target.value === null){
    dispatch(setRXOrderSelectedOldLens(null));
  }else{
    dispatch(setRXOrderSelectedOldLens(e.target.value));
  }
}


//#endregion

const onCopyLeftDataHereHandler = (e) =>{

  console.log(e.target.value);
  dispatch(copyLeftItemsToRight());

}
const onCopyRightDataHereHandler = (e) =>{

  console.log(e.target.value);
  dispatch(copyRightItemsToLeft());

}
const handleSubmitOrder = () =>{


  var errors = ValidateRXOrder(rxOrder);

  console.log(errors);
  if(errors.length === 0){
    dispatch(getRXOrderPreview({ rxOrder : rxOrder , authUser}));
  }else{
    var errorMessage = '';
    errors.map((err) => {
      errorMessage += err + '</hr>';
    });
    console.log(errorMessage);
    dispatch(setRXOrderResultBox({message : errorMessage , type : 1}));

  }
  
}

const handleYes = () => {
  setOpen(false);

  
  var errors = ValidateRXOrder(rxOrder);

  console.log(errors);
  if(errors.length === 0){
    dispatch(submitRXOrder({ rxOrder : rxOrder , authUser}));
  }else{
    var errorMessage = '';
    errors.map((err) => {
      errorMessage += err + '</hr>';
    });
    console.log(errorMessage);
    dispatch(setRXOrderResultBox({message : errorMessage , type : 1}));

  }


};

const handleClose = () => {
  setOpen(false);
};
const handleNo = () => {
  setOpen(false);
};
const handleDescriptionChange = (e) =>{
  console.log(e);
  if(e.target.value === null){
    dispatch(setRXOrderDescription(null));
  }else{
    dispatch(setRXOrderDescription(e.target.value));
  }

}
const handleStoreNameChange = (e) =>{
  if(e.target.value === null){
    dispatch(setRXOrderStoreName(null));
  }else{
    dispatch(setRXOrderStoreName(e.target.value));
  }
  

}
const handleConsumerChange = (e) =>{

  if(e.target.value === null){
    dispatch(setRXOrderConsumer(null));
  }else{
    dispatch(setRXOrderConsumer(e.target.value));
  }
}

 const handleDirectSubmitOrder = () =>{
  dispatch(setRXOrderPayType(1));
  setOpen(true);
 }
 const handleDirectSubmitOrderOnlinePayment = () =>{

  dispatch(setRXOrderPayType(2));
  setOpen(true);
 }
 const onDateMustDeliveredSelectedHandler = (e) =>{
  var day = zeroPad(e.day , 2);
  var month = zeroPad(e.month.number , 2);
  var year = e.year;

  dispatch(setRXOrderDateMustDelivered(year + "/" + month + "/"+ day));
  
}

const onBackClicked = (e) =>{

  navigate('/rxorders');

}

let timeout =  0;
var timeToSearch = 200;
const doBarcode = (e) => {
  //dispatch(resetItems());
  //
  //
  //dispatch(
  //  changeFocus('')
  //);
  var searchText = e.target.value; // this is the search text
  //
    console.log(searchText);
    console.log(doBarcode);
    if(timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
     
      dispatch(fetchProduct( {code : searchText , isFromBarcode : true , authUser}));
      console.log(barcodeItemRef);
      barcodeItemRef.current.value = '';

    }, timeToSearch);

};

return (
    <>
<ThemeProvider theme={mdTheme}>

  <Box sx={{ flexGrow: 1 }}>
     
     <Grid container>
              <Grid item xs={12}>                   
            <Accordion expanded={true}>
             
                <AccordionDetails>
                <Accordion expanded={true}>
        <AccordionSummary
          //expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          sx={{ bgcolor: '#bbdefb'}}
          >
            <Typography sx={{ width: '33%', flexShrink: 0 }}>
            <img src={customericon} style={{float: 'right'}}/>&nbsp;&nbsp;  اطلاعات مشتری</Typography>
         
        </AccordionSummary>
        <AccordionDetails>
                <Grid container 
                spacing={{ xs: 1, md: 1 }} 
                columns={{ xs: 4, sm: 8, md: 12 }}
                direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                >
                 <Grid item xs={12} sm={3} md={3} lg={3} key={9008} >
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.emergencyLevels.map(x => ({ id: x.Value, label: x.Name}))}
                        renderInput={(params) => <TextField helperText="زمان بندی تولید و تحویل" {...params} label="تحویل" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleEmergencyLevelChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.emergencyLevel}
                        value={rxOrder.emergencyLevel !== undefined ? rxOrder.emergencyLevels.map(x => ({ id: x.Value, label: x.Name})).find(r => r.id == rxOrder.emergencyLevel).label : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                      />
                    </Grid>

                    <Grid item xs={12} sm={3} md={3} lg={2} key={3}>
                    <TextField
          type="text"
          label="مصرف کننده"
          InputProps={{ inputProps: { maxLength: 18 } }}
          InputLabelProps={{
            shrink: true,
          }}
          sx={{
            //width: 200,
            '.MuiInputBase-input': { fontSize: '13px' },
          }}
          helperText="به صورت انگلیسی وارد شود"
          fullWidth
          defaultValue=""
          variant="standard"
          value={rxOrder.consumer}
          onChange={evt => handleConsumerChange(evt)}
        />
                    </Grid>
                    
                    <Grid item xs={12} sm={3} md={3} lg={2} key={2}>
                    
                      
       <TextField
          type="text"
          label="نام فروشگاه"
          InputProps={{ inputProps: { maxLength: 18 } }}
          InputLabelProps={{
            shrink: true,
          }}
          sx={{
            //width: 200,
            '.MuiInputBase-input': { fontSize: '13px' },
          }}
          helperText="به صورت انگلیسی وارد شود"
          fullWidth
          defaultValue=""
          variant="standard"
          value={rxOrder.storeName}

          onChange={evt => handleStoreNameChange(evt)}>

          </TextField>
   
   
      
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={2} key={1}>
                     
                     <Controller
                           name="مشتری"
                           render={({ field }) => (
                             <Autocomplete
                             options={authUser.underControlUsers.map(x => ({ id: x.Value, label: x.Code + ' ' + x.Name}))}
                             //getOptionLabel={option => option}
                             renderOption={(props, option, state) => 
                               <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                 {option.label}
                               </div>
                             }
                             //filterSelectedOptions
                             renderInput={params => (
                               <TextField
                                 {...params}
                                 error={rxOrder.customerPortalUserId === undefined || rxOrder.customerPortalUserId === null || rxOrder.customerPortalUserId === ""}
                                 helperText="مشتری"
                                 variant="outlined"
                                 label="مشتری"
                                 placeholder=""
                                 sx={{
                                   //width: 200,
                                   '.MuiInputBase-input': { fontSize: '13px' },
                                 }}
                               />
                             )}
                             onChange={handleCustomerPortalUserChange}
                             value={rxOrder.customerPortalUserId !== undefined && rxOrder.customerPortalUserId !== null && rxOrder.customerPortalUserId !== "" ? authUser.underControlUsers.find(r => r.Value == rxOrder.customerPortalUserId).Code : ''}
                             size="small"
                             noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                             autoHighlight='true'
                             //disabled={(rxOrder.LSPH === null)}
                           />
                           )}
                           control={control}
                           rules={{
                             validate: d => {
                               return d.length > 0;
                             }
                           }}
                         />
                     </Grid>
                   
                   </Grid>
                
             
  </AccordionDetails>
          </Accordion>

                <Accordion expanded={true}>
        <AccordionSummary
          //expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          sx={{ bgcolor: '#bbdefb'}}
          >
            <Typography sx={{ width: '33%', flexShrink: 0 }}>
            <img src={productbrand} style={{float: 'right'}}/>&nbsp;&nbsp; مشخصات محصول</Typography>
         
        </AccordionSummary>
        <AccordionDetails>
                <Grid container 
                spacing={{ xs: 1, md: 1 }} 
                columns={{ xs: 4, sm: 8, md: 12 }}
                direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                >
                    <Grid item xs={12} sm={4} md={3} lg={2} key={1}>
                     
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.lensbrands.map(x => ({ id: x.Value, label: x.Name}))}
                        renderInput={(params) => 
                        <TextField {...params} label="Brand" InputLabelProps={{ disableAnimation: true , color : 'success' , sx : { typography: 'body1', fontWeight: 'fontWeightLight' } }} 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensBrandChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedLensBrandId}
                        //value={rxOrder.selectedLensBrandId > 0 ? rxOrder.selectedLensBrandId : ''}
                        value={rxOrder.selectedLensBrandId > 0 ? rxOrder.lensbrands.map(x => ({ id: x.Value, label: x.Name})).find(r => r.id == rxOrder.selectedLensBrandId).label : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                        //disabled={rxOrder.isLeftOn}
                      />
                     
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} lg={2} key={2}>
                    
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.lensTypes.map(x => ({ id: x.Value, label: x.Name }))}
                        renderInput={(params) => <TextField {...params} label="Lens Type" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensTypeChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedLensTypeId}
                        //value={rxOrder.selectedLensTypeId}
                        value={rxOrder.selectedLensTypeId > 0 ? rxOrder.lensTypes.find(r => r.Value == rxOrder.selectedLensTypeId).Name : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                        //disabled={rxOrder.isLeftOn}
                      />
                     
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} lg={2} key={3}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.lensDesignTypes.map(x => ({ id: x.Value, label: x.Name}))}
                        renderInput={(params) => <TextField {...params} label="Design Type" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensDesignTypeChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedLensDesignTypeId}
                        //value={rxOrder.selectedLensDesignTypeId}
                        value={rxOrder.selectedLensDesignTypeId > 0 ? rxOrder.lensDesignTypes.find(r => r.Value == rxOrder.selectedLensDesignTypeId).Name : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                        //disabled={rxOrder.isLeftOn}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} lg={2} key={4}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.lensIndexes.map(x => ({ id: x.Value, label: x.Name}))}
                        renderInput={(params) => <TextField {...params} label="Lens Index" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensIndexChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedLensIndexId}
                        //value={rxOrder.selectedLensIndexId}
                        value={rxOrder.selectedLensIndexId > 0 ? rxOrder.lensIndexes.find(r => r.Value == rxOrder.selectedLensIndexId).Name : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                        //disabled={rxOrder.isLeftOn}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3} lg={2} key={5}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.lensMaterialTypes.map(x => ({ id: x.Value, label: x.Name}))}
                        renderInput={(params) => <TextField {...params} label="Material Type" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLensMaterialTypeChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedLensMaterialTypeId}
                        //value={rxOrder.selectedLensMaterialTypeId}
                        value={rxOrder.selectedLensMaterialTypeId > 0 ? rxOrder.lensMaterialTypes.find(r => r.Value == rxOrder.selectedLensMaterialTypeId).Name : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                        //disabled={rxOrder.isLeftOn}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={5} lg={2} key={6}>
                      <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={rxOrder.products.map(x => ({ id: x.Value, label: x.Name}))}
                          renderInput={(params) => <TextField {...params} label="Product" 
                          sx={{
                            //width: 135,
                            '.MuiInputBase-input': { fontSize: '13px' },
                          }}
                          />}
                          renderOption={(props, option, state) => 
                            <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                              {option.label}
                            </div>
                          }
                          onChange={handleProductChange}
                          //isOptionEqualToValue={(option, value) =>  option.id === value.id}
                          value={rxOrder.selectedProductId > 0 ? rxOrder.products.find(r => r.Value == rxOrder.selectedProductId).Name : ''}
                          size="small"
                          noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                          autoHighlight='true'
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2} lg={2} key={7}>
                     
                    <Controller
                          name="Coating"
                          render={({ field }) => (
                            <Autocomplete
                            id="Coating"
                            options={rxOrder.coatings.map(x => ({ id: x.Value, label: x.Name}))}
                            //getOptionLabel={option => option}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                error={rxOrder.selectedCoatingId == null}
                                helperText="پوشش عدسی"
                                variant="outlined"
                                label="COATING"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleCoatingChange}
                            isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedCoatingId}
                            //value={rxOrder.selectedCoatingId}
                            value={rxOrder.selectedCoatingId > 0 ? rxOrder.coatings.find(r => r.Value == rxOrder.selectedCoatingId).Name : ''}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            autoHighlight='true'
                            //disabled={(rxOrder.LSPH === null)}
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />
                     
                   </Grid>
                   <Grid item xs={12} sm={4} md={2} lg={2} key={8}>
                     
                     <Autocomplete
                       disablePortal
                       id="combo-box-demo"
                       options={rxOrder.corridors.map(x => ({ id: x.Value, label: x.Name}))}
                       renderInput={(params) => <TextField {...params} label="Corridor" 
                       sx={{
                         //width: 135,
                         '.MuiInputBase-input': { fontSize: '13px' },
                       }}
                       />}
                       renderOption={(props, option, state) => 
                         <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                           {option.label}
                         </div>
                       }
                       onChange={handleCorridorChange}
                       isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedCorridor}
                       value={rxOrder.selectedCorridor}
                       size="small"
                       noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                       disabled={GetCorridorState(rxOrder)}
                       autoHighlight='true'
                     />
                   </Grid>
                </Grid>
              
              

  </AccordionDetails>
          </Accordion>

                <Accordion expanded={true}>
        <AccordionSummary
          //expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          sx={{ bgcolor: '#bbdefb'}}
          >
            <Typography sx={{ width: '33%', flexShrink: 0 }}>
            <img src={leftrighteye} style={{float: 'right'}}/>&nbsp;&nbsp; مشخصات چشم راست و چپ</Typography>
        </AccordionSummary>
        <AccordionDetails>
                <Grid container 
                spacing={{ xs: 1, md: 1 }} 
                columns={{ xs: 4, sm: 8, md: 12 }}
                direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                >


          <Grid item xs={12} sm={6} md={6} lg={6} key={2000}>
            
          <Card >
          <img src={ron} style={{float: 'left'}}/>
      <CardContent>
      <Divider />
        <Typography gutterBottom variant="h6" component="div"  align="center">
         RIGHT EYE
        </Typography>
        <Divider />
        <Grid container 
                spacing={{ xs: 1, sm : 1, md: 1 , lg : 1 }} 
                columns={{ xs: 4, sm: 8, md: 12 , lg : 12 }}
                direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                >
                    <Grid item xs={12} sm={1} md={1} lg={1} key={98-1}>
                      <PositiveNegativeSwitch checked={rxOrder.RSPHSign === "true"} onChange={handleRSPHSign} size="small"/>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3} key={98} >
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.Sphs.map(x => ({ id: x, label: x}))}
                        renderInput={(params) => <TextField helperText="توان اسفریک" {...params} label="R SPH" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleRSPHChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RSPH}
                        value={rxOrder.RSPH}
                        //value={rxOrder.RSPH !== null ? rxOrder.Sphs.find(r => r == rxOrder.RSPH) : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                        //disabled={rxOrder.isLeftOn}
                      />
                     

                    </Grid>
                    <Grid item xs={12} sm={1} md={1} lg={1} key={118-1}>
                    <PositiveNegativeSwitch checked={rxOrder.RCYLSign === "true"} onChange={handleRCYLSign} size="small"/>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3} key={10} >

                    <Controller
                          name="RCYL"
                          render={({ field }) => (
                            <Autocomplete
                            fullWidth
                            id="RCYL"
                            options={rxOrder.Cyls.map(x => ({ id: x, label: x}))}
                            //getOptionLabel={option => option}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                //error={rxOrder.RSPH !== null && (rxOrder.RCYL === null || rxOrder.RCYL === "")}
                                helperText="آستیگمات"
                                variant="outlined"
                                label="R CYL"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleRCYLChange}
                            isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RCYL}
                            value={rxOrder.RCYL}
                            //value={rxOrder.RCYL !== null ? rxOrder.Cyls.find(r => r == rxOrder.RCYL) : ''}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            disabled={(rxOrder.RSPH === null)}
                            autoHighlight='true'
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />
                    

                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3} key={118}>
                  <Controller
                          name="RAxis"
                          render={({ field }) => (
                            <Autocomplete
                            fullWidth
                            id="RAxis"
                            options={rxOrder.Axiss.map(x => ({ id: x, label: x}))}
                            //getOptionLabel={option => option}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                error={(rxOrder.RSPH !== null && (rxOrder.RCYL !== "0.00" && rxOrder.RCYL !== "" && rxOrder.RCYL !== null) && (rxOrder.RAXIS === "" || rxOrder.RAXIS === null || rxOrder.RAXIS < 0 || rxOrder.RAXIS > 180))}
                                helperText="محور آستیگمات"
                                variant="outlined"
                                label="R Axis"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleRAXISChange}
                            isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RAXIS}
                            value={rxOrder.RAXIS}
                            //value={rxOrder.RAXIS !== null ? rxOrder.Axiss.find(r => r == rxOrder.RAXIS).toString() : ''}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            disabled={(rxOrder.RSPH === null)}
                            autoHighlight='true'
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />
                    {/* 
                    <TextField
                      label="R Axis"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { min: 0, max: 180 , step : 1 , maxLength: 12 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleRAXISChange}
                      value={rxOrder.RAXIS === null ? '' : rxOrder.RAXIS}
                      error={(rxOrder.RSPH !== null && (rxOrder.RCYL !== "0.00" && rxOrder.RCYL !== "" && rxOrder.RCYL !== null) && (rxOrder.RAXIS === "" || rxOrder.RAXIS === null || rxOrder.RAXIS < 0 || rxOrder.RAXIS > 180))}
                      helperText="Right Axis"
                      disabled={(rxOrder.RSPH === null)}
                    />
                  */}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={3} key={12}>
                      <Controller
                          name="RADD"
                          render={({ field }) => (
                            <Autocomplete
                            id="RADD"
                            options={rxOrder.ADDs.map(x => ({ id: x, label: x}))}
                            //getOptionLabel={option => option}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                error={!IsRightAddValid(rxOrder)}
                                helperText="ادیشن"
                                variant="outlined"
                                label="R ADD"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleRAddChange}
                            isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RADD}
                            value={rxOrder.RADD}
                            //value={rxOrder.RADD !== null ? rxOrder.ADDs.find(r => r == rxOrder.RADD) : ''}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            disabled={GetAddState(rxOrder)}
                            autoHighlight='true'
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />

                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} key={13}>

                    <Autocomplete
                       disablePortal
                       id="combo-box-demo"
                       options={rxOrder.DIAs.map(x => ({ id: x, label: x}))}
                       renderInput={(params) => <TextField helperText="قطر عدسی" {...params} label="R DIA" 
                       sx={{
                         //width: 135,
                         '.MuiInputBase-input': { fontSize: '13px' },
                       }}
                       />}
                       renderOption={(props, option, state) => 
                         <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                           {option.label}
                         </div>
                       }
                       onChange={handleRDiaChange}
                       isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RDIA}
                       value={rxOrder.RDIA}
                       //value={rxOrder.RDIA !== null ? rxOrder.DIAs.find(r => r == rxOrder.RDIA) : ''}
                       size="small"
                       noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                       disabled={(rxOrder.RSPH === null)}
                       autoHighlight='true'

                     />

                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={3} key={14}>

                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.DCs.map(x => ({ id: x, label: x}))}
                        renderInput={(params) => <TextField helperText="مقدار دسانتره" {...params} label="R DC" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleRDCChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RDC}
                        value={rxOrder.RDC}
                        //value={rxOrder.RDC !== null ? rxOrder.DCs.find(r => r == rxOrder.RDC) : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        disabled={(rxOrder.RSPH === null)}
                        autoHighlight='true'
                      />

                      </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} key={15}>
                    <Controller
                            name="RPosition"
                            render={({ field }) => (
                              <Autocomplete
                              id="RPosition"
                              options={rxOrder.Positions.map(x => ({ id: x.Value, label: x.Name }))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              //filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  error={rxOrder.RDC !== null && rxOrder.RPosition === null}
                                  helperText="جهت دسانتره"
                                  variant="outlined"
                                  label="R Position"
                                  placeholder=""
                                  sx={{
                                    //width: 135,
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onChange={handleRPositionChange}
                              isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RPosition}
                              value={rxOrder.RPosition}
                              //value={rxOrder.RPosition !== null ? rxOrder.Positions.find(r => r.Value == rxOrder.RPosition).Name : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              //disabled={(rxOrder.RPrism === null || (rxOrder.RPrism !== null && rxOrder.RPrism.length === 0))}
                              disabled={rxOrder.RDC === null}
                              autoHighlight='true'
                            />
                            )}
                            control={control}
                            rules={{
                              validate: d => {
                                return d.length > 0;
                              }
                            }}
                          />


                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={4} key={16}>

                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={rxOrder.Prisms.map(x => ({ id: x, label: x }))}
                          renderInput={(params) => <TextField helperText="توان پریزم" {...params} label="R Prism" 
                          sx={{
                            //width: 135,
                            '.MuiInputBase-input': { fontSize: '13px' },
                          }}
                          />}
                          renderOption={(props, option, state) => 
                            <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                              {option.label}
                            </div>
                          }
                          onChange={handleRPrismChange}
                          isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RPrism}
                          value={rxOrder.RPrism}
                          //value={rxOrder.RPrism !== null ? rxOrder.Prisms.find(r => r == rxOrder.RPrism) : ''}
                          size="small"
                          noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                          disabled={(rxOrder.RSPH === null)}
                          autoHighlight='true'
                        />

                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={4} key={17}>
                        <Controller
                            name="RBaseofPrism"
                            render={({ field }) => (
                              <Autocomplete
                              id="RBaseofPrism"
                              options={rxOrder.BaseOfPrisms.map(x => ({ id: x.Value, label: x.Name }))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              //filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  error={rxOrder.RPrism !== null && rxOrder.RBaseOfPrism === null}
                                  helperText="جهت بیس پریزم"
                                  variant="outlined"
                                  label="R Base of Prism"
                                  placeholder=""
                                  sx={{
                                    //width: 135,
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onChange={handleRBaseOfPrismChange}
                              isOptionEqualToValue={(option, value) =>  option.id === rxOrder.RBaseOfPrism}
                              value={rxOrder.RBaseOfPrism}
                              //value={rxOrder.RBaseOfPrism !== null ? rxOrder.BaseOfPrisms.find(r => r.Value == rxOrder.RBaseOfPrism).Name : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              disabled={(rxOrder.RPrism === null || (rxOrder.RPrism !== null && rxOrder.RPrism.length === 0))}
                              autoHighlight='true'
                            />
                            )}
                            control={control}
                            rules={{
                              validate: d => {
                                return d.length > 0;
                              }
                            }}
                          />
                      
                        </Grid>


                </Grid>
      </CardContent>
      <CardActions 
        sx={{
          alignSelf: "stretch",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          // 👇 Edit padding to further adjust position
          p: 0,
        }}
      >
      <Typography sx={{ color: 'text.secondary' }}>
            <Button variant="outlined" color="success" endIcon={<ContentCopyIcon />} startIcon={<SubdirectoryArrowLeftIcon color="primary"/>} onClick={onCopyLeftDataHereHandler}>
            &nbsp;&nbsp;کپی اطلاعات چشم چپ
          </Button>  </Typography>
      </CardActions>
    </Card>

          
  
  </Grid>
  <Grid item xs={12} sm={6} md={6} lg={6} key={1000}>

   <Card>
      <img src={lon} style={{float: 'right'}}/>
      <CardContent>
      <Divider />
        <Typography gutterBottom variant="h6" component="div" align="center">
         LEFT EYE
        </Typography>
        <Divider />
        <Grid container 
                spacing={{ xs: 1, sm: 1, md: 1, lg : 1 }} 
                columns={{ xs: 4, sm: 8, md: 12 , lg : 12 }}
                direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                >
                     <Grid item xs={12} sm={1} md={1} lg={1} key={99-1} >
                     <PositiveNegativeSwitch checked={rxOrder.LSPHSign === "true"} onChange={handleLSPHSign} size="small"/>
                     </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3} key={99}>
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.Sphs.map(x => ({ id: x, label: x}))}
                        renderInput={(params) => <TextField helperText="توان اسفریک" {...params} label="L SPH" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLSPHChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LSPH}
                        value={rxOrder.LSPH}
                        //value={rxOrder.LSPH !== null ? rxOrder.Sphs.find(r => r == rxOrder.LSPH) : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        autoHighlight='true'
                        //disabled={rxOrder.isLeftOn}
                      />
                    </Grid>
                    <Grid item xs={12} sm={1} md={1} lg={1} key={109-1} >
                    <PositiveNegativeSwitch checked={rxOrder.LCYLSign === "true"} onChange={handleLCYLSign} size="small"/>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3} key={109} >
                        <Controller
                          name="LCYL"
                          render={({ field }) => (
                            <Autocomplete
                            fullWidth
                            id="LCYL"
                            options={rxOrder.Cyls.map(x => ({ id: x, label: x}))}
                            //getOptionLabel={option => option}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                //error={rxOrder.LSPH !== null && (rxOrder.LCYL === null || rxOrder.LCYL === "")}
                                helperText="آستیگمات"
                                variant="outlined"
                                label="L CYL"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleLCYLChange}
                            isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LCYL}
                            value={rxOrder.LCYL}
                            //value={rxOrder.LCYL !== null  ? rxOrder.Cyls.find(r => r == rxOrder.LCYL) : ''}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            disabled={(rxOrder.LSPH === null)}
                            autoHighlight='true'
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3} lg={3} key={119} >

                  <Controller
                          name="LAxis"
                          render={({ field }) => (
                            <Autocomplete
                            fullWidth
                            id="LAxis"
                            options={rxOrder.Axiss.map(x => ({ id: x, label: x}))}
                            //getOptionLabel={(option)=>(option.name?option.name:'')}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                error={(rxOrder.LSPH !== null && (rxOrder.LCYL !== "0.00" && rxOrder.LCYL !== "" && rxOrder.LCYL !== null) && (rxOrder.LAXIS === "" || rxOrder.LAXIS === null || rxOrder.LAXIS < 0 || rxOrder.LAXIS > 180))}
                                helperText="محور آستیگمات"
                                variant="outlined"
                                label="L Axis"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleLAXISChange}
                            isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LAXIS}
                            value={rxOrder.LAXIS}
                            //value={rxOrder.LAXIS !== null ? rxOrder.Axiss.find(r => r == rxOrder.LAXIS).toString() : ''}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            disabled={(rxOrder.LSPH === null)}
                            autoHighlight='true'
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />
                     {/* 
                    <TextField
                      label="L Axis"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { min: 0, max: 180 , step : 1 , maxLength: 12} }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleLAXISChange}
                      value={rxOrder.LAXIS === null ? '' : rxOrder.LAXIS}
                      error={(rxOrder.LSPH !== null && (rxOrder.LCYL !== "0.00" && rxOrder.LCYL !== "" && rxOrder.LCYL !== null) && (rxOrder.LAXIS === "" || rxOrder.LAXIS === null || rxOrder.LAXIS < 0 || rxOrder.LAXIS > 180))}
                      helperText="Left Axis"
                      disabled={(rxOrder.LSPH === null)}
                    />
                    */}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={3} key={12}>
                    <Controller
                            name="LADD"
                            render={({ field }) => (
                              <Autocomplete
                              id="LADD"
                              options={rxOrder.ADDs.map(x => ({ id: x, label: x}))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              //filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  error={!IsLeftAddValid(rxOrder)}
                                  helperText="ادیشن"
                                  variant="outlined"
                                  label="L ADD"
                                  placeholder=""
                                  sx={{
                                    //width: 135,
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onChange={handleLAddChange}
                              isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LADD}
                              value={rxOrder.LADD}
                              //value={rxOrder.LADD !== null ? rxOrder.ADDs.find(r => r == rxOrder.LADD) : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              disabled={GetAddState(rxOrder)}
                              autoHighlight='true'
                            />
                            )}
                            control={control}
                            rules={{
                              validate: d => {
                                return d.length > 0;
                              }
                            }}
                          />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} key={13}>
                    <Autocomplete
                       disablePortal
                       id="combo-box-demo"
                       options={rxOrder.DIAs.map(x => ({ id: x, label: x}))}
                       renderInput={(params) => <TextField helperText="قطر عدسی" {...params} label="L DIA" 
                       sx={{
                         //width: 135,
                         '.MuiInputBase-input': { fontSize: '13px' },
                       }}
                       />}
                       renderOption={(props, option, state) => 
                         <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                           {option.label}
                         </div>
                       }
                       onChange={handleLDiaChange}
                       isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LDIA}
                       value={rxOrder.LDIA}
                       //value={rxOrder.LDIA !== null ? rxOrder.DIAs.find(r => r == rxOrder.LDIA) : ''}
                       size="small"
                       noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                       disabled={(rxOrder.LSPH === null)}
                       autoHighlight='true'
                     />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={3} key={14}>
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={rxOrder.DCs.map(x => ({ id: x, label: x}))}
                        renderInput={(params) => <TextField helperText="مقدار دسانتره" {...params} label="L DC" 
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        />}
                        renderOption={(props, option, state) => 
                          <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                            {option.label}
                          </div>
                        }
                        onChange={handleLDCChange}
                        isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LDC}
                        value={rxOrder.LDC}
                        //value={rxOrder.LDC !== null ? rxOrder.DCs.find(r => r == rxOrder.LDC) : ''}
                        size="small"
                        noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                        disabled={(rxOrder.LSPH === null)}
                        autoHighlight='true'
                      />
                      </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={4} key={15}>
                    <Controller
                            name="LPosition"
                            render={({ field }) => (
                              <Autocomplete
                              id="LPosition"
                              options={rxOrder.Positions.map(x => ({ id: x.Value, label: x.Name }))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              //filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  error={rxOrder.LDC !== null && rxOrder.LPosition === null}
                                  helperText="جهت دسانتره"
                                  variant="outlined"
                                  label="L Position"
                                  placeholder=""
                                  sx={{
                                    //width: 135,
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onChange={handleLPositionChange}
                              isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LPosition}
                              value={rxOrder.LPosition}
                              //value={rxOrder.LPosition !== null ? rxOrder.Positions.find(r => r.Value == rxOrder.LPosition).Name : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              //disabled={(rxOrder.LPrism === null || (rxOrder.LPrism !== null && rxOrder.LPrism.length === 0))}
                              disabled={rxOrder.LDC === null}
                              autoHighlight='true'
                            />
                            )}
                            control={control}
                            rules={{
                              validate: d => {
                                return d.length > 0;
                              }
                            }}
                          />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={4} key={16}>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={rxOrder.Prisms.map(x => ({ id: x, label: x }))}
                          renderInput={(params) => <TextField  helperText="توان پریزم" {...params} label="L Prism" 
                          sx={{
                            //width: 135,
                            '.MuiInputBase-input': { fontSize: '13px' },
                          }}
                          />}
                          renderOption={(props, option, state) => 
                            <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                              {option.label}
                            </div>
                          }
                          onChange={handleLPrismChange}
                          isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LPrism}
                          value={rxOrder.LPrism}
                          //value={rxOrder.LPrism !== null ? rxOrder.Prisms.find(r => r == rxOrder.LPrism) : ''}
                          size="small"
                          noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                          disabled={(rxOrder.LSPH === null)}
                          autoHighlight='true'
                        />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} key={17}>

                        <Controller
                            name="LBaseofPrism"
                            render={({ field }) => (
                              <Autocomplete
                              id="LBaseofPrism"
                              options={rxOrder.BaseOfPrisms.map(x => ({ id: x.Value, label: x.Name }))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              //filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  error={rxOrder.LPrism !== null && rxOrder.LBaseOfPrism === null}
                                  helperText="جهت بیس پریزم"
                                  variant="outlined"
                                  label="L Base of Prism"
                                  placeholder=""
                                  sx={{
                                    //width: 135,
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onChange={handleLBaseOfPrismChange}
                              isOptionEqualToValue={(option, value) =>  option.id === rxOrder.LBaseOfPrism}
                              value={rxOrder.LBaseOfPrism}
                              //value={rxOrder.LBaseOfPrism !== null ? rxOrder.BaseOfPrisms.find(r => r.Value == rxOrder.LBaseOfPrism).Name : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              disabled={(rxOrder.LPrism === null || (rxOrder.LPrism !== null && rxOrder.LPrism.length === 0))}
                              autoHighlight='true'
                            />
                            )}
                            control={control}
                            rules={{
                              validate: d => {
                                return d.length > 0;
                              }
                            }}
                          />

                        </Grid>
        </Grid>
      </CardContent>
      <CardActions
        sx={{
          color: 'text.secondary',
          alignSelf: "stretch",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          // 👇 Edit padding to further adjust position
          p: 0,
        }}
      >
      <Typography sx={{ color: 'text.secondary' }}>
          <Button variant="outlined" color="success" startIcon={<ContentCopyIcon />} endIcon={<SubdirectoryArrowRightIcon color="primary"/>} onClick={onCopyRightDataHereHandler}>
            کپی اطلاعات چشم راست
          </Button>
          </Typography>
      </CardActions>
    </Card>
          
          </Grid>
</Grid>
        </AccordionDetails>

      </Accordion>
      <Accordion expanded={true}>
        <AccordionSummary
          //expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          sx={{ bgcolor: '#bbdefb'}}
        >
          <Typography sx={{ width: '33%', flexShrink: 0 }}>
          <img src={framesize} style={{float: 'right'}}/>&nbsp;&nbsp;ابعاد فریم
          </Typography>
       
        </AccordionSummary>
        <AccordionDetails>
         
         
        <Grid container 
                spacing={{ xs: 1, md: 1 }} 
                columns={{ xs: 4, sm: 8, md: 12 }}
                direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                >
                    <Grid item xs={12} sm={4} md={1} lg={2} key={18} >
                    <TextField
                      label="HBOX"
                      type="number"
                      helperText="عرض حدقه"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleHBOXChange}
                      value={rxOrder.HBOX === null ? '' : rxOrder.HBOX}
                      disabled={(rxOrder.RDIA !== null) || (rxOrder.LDIA !== null)}
                      error={((rxOrder.RDIA === null) && (rxOrder.LDIA === null)) && rxOrder.HBOX === null}
                     
                    />
                    </Grid>

                    <Grid item xs={12} sm={4} md={1} lg={2} key={19} >
                    <TextField
                      label="VBOX"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleVBOXChange}
                      value={rxOrder.VBOX === null ? '' : rxOrder.VBOX}
                      disabled={(rxOrder.RDIA !== null ) || (rxOrder.LDIA !== null )}
                      error={((rxOrder.RDIA === null) && (rxOrder.LDIA === null)) && rxOrder.VBOX === null}
                      helperText="ارتفاع حدقه"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={20} >
                    <TextField
                      label="FITTING-R"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { min : 1 , step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleFITTINGRChange}
                      value={rxOrder.FITTINGR === null ? '' : rxOrder.FITTINGR}
                      disabled={!(rxOrder.RSPH !== null)}
                      error={(rxOrder.RSPH !== null && (rxOrder.FITTINGR !== null && rxOrder.FITTINGR < 1))}

                      helperText="فیتینگ/سگمنت چشم راست"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={21} >
                    <TextField
                      label="FITTING-L"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { min : 1 , step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleFITTINGLChange}
                      value={rxOrder.FITTINGL === null ? '' : rxOrder.FITTINGL}
                      disabled={!(rxOrder.LSPH !== null)}
                      error={(rxOrder.LSPH !== null && (rxOrder.FITTINGL !== null && rxOrder.FITTINGL < 1))}
                      helperText="فیتینگ/سگمنت چشم چپ"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={22} >
                    <TextField
                      label="DBL"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleDBLChange}
                      value={rxOrder.DBL === null ? '' : rxOrder.DBL}
                      helperText="اندازه پل"
                      error={(rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.DBL === null)}
                      //disabled={!(rxOrder.LSPH !== null && rxOrder.LSPH.length > 0)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={23} >
                    <TextField
                      label="ED"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleEDChange}
                      value={rxOrder.ED === null ? '' : rxOrder.ED}
                      helperText="قطر موثر"
                      error={(rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.ED === null)}

                      //disabled={!(rxOrder.LSPH !== null && rxOrder.LSPH.length > 0)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={24} >
                    <TextField
                      label="PANTO"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { min : -1 , max :30 , step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handlePANTOChange}
                      value={rxOrder.PANTO === null ? '' : rxOrder.PANTO}
                      error={(rxOrder.PANTO !== null && (rxOrder.PANTO < -1 || rxOrder.PANTO > 30))}
                      helperText="شیب پانتوسکوپیک"
                      //disabled={!(rxOrder.LSPH !== null && rxOrder.LSPH.length > 0)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={25} >
                    <TextField
                      label="FFA"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { min : 0 , max : 30 , step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleFFAChange}
                      value={rxOrder.FFA === null ? '' : rxOrder.FFA}
                      error={(rxOrder.FFA !== null && (rxOrder.FFA < -1 || rxOrder.FFA > 30))}
                      helperText="بیس فریم"
                      //disabled={!(rxOrder.LSPH !== null && rxOrder.LSPH.length > 0)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={26} >
                    <TextField
                      label="BVD"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { min : 1 , max : 30,  step : 0.01 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleBVDChange}
                      value={rxOrder.BVD === null ? '' : rxOrder.BVD}
                      helperText="فاصله قرنیه تا سطح پشت عدسی"
                      //disabled={!(rxOrder.LSPH !== null && rxOrder.LSPH.length > 0)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={27} >
                      <Autocomplete
                          disablePortal
                          disableClearable={true}
                          id="combo-box-demo"
                          options={rxOrder.BASEs.map(x => ({ id: x, label: x }))}
                          renderInput={(params) => <TextField  helperText="بیس عدسی" {...params} label="BASE" 
                          sx={{
                            //width: 135,
                            '.MuiInputBase-input': { fontSize: '13px' },
                          }}
                          />}
                          renderOption={(props, option, state) => 
                            <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                              {option.label}
                            </div>
                          }
                          onChange={handleBASEChange}
                          isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedBase}
                          value={rxOrder.selectedBase}
                          //value={rxOrder.selectedBase !== null && rxOrder.BASEs.length > 0 ? rxOrder.BASEs.find(r => r == rxOrder.selectedBase) : ''}
                          size="small"
                          noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                          autoHighlight='true'
                          //disabled={(rxOrder.LPrism === null || (rxOrder.LPrism !== null && rxOrder.LPrism.length === 0))}
                        />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={28} >
                    <TextField
                      label="IPDR"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleIPDRChange}
                      value={rxOrder.IPDR === null ? '' : rxOrder.IPDR}
                      disabled={!(rxOrder.RSPH !== null)}
                      error={(rxOrder.RSPH !== null && rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.DBL !== null && rxOrder.IPDR === null)}
                      helperText="PD چشم راست"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={29} >
                  <TextField
                      label="IPDL"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      InputProps={{ inputProps: { step : 0.1 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleIPDLChange}
                      value={rxOrder.IPDL === null ? '' : rxOrder.IPDL}
                      disabled={!(rxOrder.LSPH !== null )}
                      error={(rxOrder.LSPH !== null && rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.DBL !== null && rxOrder.IPDL === null)}
                      helperText="PD چشم چپ"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={30} >
                        <Controller
                            name="FRAMETYPE"
                            render={({ field }) => (
                              <Autocomplete
                              id="FRAMETYPE"
                              options={rxOrder.FrameTypes.map(x => ({ id: x.Value, label: x.Name }))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              //filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  error={rxOrder.HBOX !== null && rxOrder.VBOX !== null && rxOrder.selectedFrameType === null}
                                  helperText="نوع فریم"
                                  variant="outlined"
                                  label="FRAME TYPE"
                                  placeholder=""
                                  sx={{
                                    //width: 135,
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onChange={handleFrameTypeChange}
                              isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedFrameType}
                              //value={rxOrder.selectedFrameType}
                              value={rxOrder.selectedFrameType !== null ? rxOrder.FrameTypes.find(r => r.Value == rxOrder.selectedFrameType).Name : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              autoHighlight='true'
                              //disabled={GetAddState(rxOrder)}
                            />
                            )}
                            control={control}
                            rules={{
                              validate: d => {
                                return d.length > 0;
                              }
                            }}
                          />
                  </Grid>
                </Grid>
              
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={true}>
        <AccordionSummary
          //expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          sx={{ bgcolor: '#bbdefb'}}
          >
            <Typography sx={{ width: '33%', flexShrink: 0 }}>
            <img src={colorandservice} style={{float: 'right'}}/>&nbsp;&nbsp; رنگ و خدمات</Typography>
         
        </AccordionSummary>
        <AccordionDetails>
        <Grid container 
                spacing={{ xs: 1, md: 1 }} 
                columns={{ xs: 4, sm: 8, md: 12 }}
                direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={31} >
                        <Controller
                            name="COLORINGTYPE"
                            render={({ field }) => (
                              <Autocomplete
                              id="COLORINGTYPE"
                              options={rxOrder.coloringTypes.map(x => ({ id: x.Value, label: x.Name }))}
                              //getOptionLabel={option => option}
                              renderOption={(props, option, state) => 
                                <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                  {option.label}
                                </div>
                              }
                              //filterSelectedOptions
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  error={!IsColoringTypeValid(rxOrder)}
                                  helperText="نوع رنگ آمیزی"
                                  variant="outlined"
                                  label="COLORING TYPE"
                                  placeholder=""
                                  sx={{
                                    //width: 135,
                                    '.MuiInputBase-input': { fontSize: '13px' },
                                  }}
                                />
                              )}
                              onChange={handleLColoringTypeChange}
                              isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedColoringType}
                              //value={rxOrder.selectedColoringType}
                              value={rxOrder.selectedColoringType !== null ? rxOrder.coloringTypes.map(x => ({ id: x.Value, label: x.Name })).find(r => r.id == rxOrder.selectedColoringType).label : ''}
                              size="small"
                              noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                              autoHighlight='true'
                              //disabled={GetAddState(rxOrder)}
                            />
                            )}
                            control={control}
                            rules={{
                              validate: d => {
                                return d.length > 0;
                              }
                            }}
                          />      
                  </Grid>
                  <Grid item xs={12} sm={4} md={2} lg={2} key={32} >
                      <Controller
                          name="contentTypes"
                          render={({ field }) => (
                            <Autocomplete
                            id="contentTypes"
                            options={rxOrder.colors.map(x => ({ id: x.Value, label: x.Name }))}
                            ////getOptionLabel={option => option}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                error={!((rxOrder.selectedColoringType === null || rxOrder.selectedColoringType.toString() === "3")) && (rxOrder.selectedColor === null || rxOrder.selectedColor === "")}
                                helperText="انتخاب رنگ"
                                variant="outlined"
                                label="COLOR"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleLColorChange}
                            isOptionEqualToValue={(option, value) =>  option.id === rxOrder.selectedColor}
                            value={rxOrder.selectedColor}
                            //value={rxOrder.selectedColor !== null ? rxOrder.colors.find(r => r.Value == rxOrder.selectedColor).Name : ''}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            disabled={(rxOrder.selectedColoringType === null || rxOrder.selectedColoringType.toString() === "3")}
                            autoHighlight='true'
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />
                  </Grid>
                  <Grid item xs={12} sm={4} md={1} lg={2} key={33} >
                    <TextField
                      label="Color Ratio"
                      type="number"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        //width: 135,
                        '.MuiInputBase-input': { fontSize: '13px' },
                      }}
                      error={(rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType === "1" && (rxOrder.colorRate === "" || rxOrder.colorRate === null || rxOrder.colorRate < 0 || rxOrder.colorRate > 100))}
                      helperText="درصد رنگ"
                      InputProps={{ inputProps: { min : 0 , max : 100 , step : 10 } }}
                      size="small"
                      variant="standard"
                      fullWidth
                      onChange={handleColoingRateChange}
                      value={rxOrder.colorRate === null ? '' : rxOrder.colorRate}
                      disabled={!(rxOrder.selectedColoringType !== null && (rxOrder.selectedColoringType.toString() === "1" || rxOrder.selectedColoringType.toString() === "3"))}

                    />
                    </Grid>
                    <Grid item xs={12} sm={4} md={1} lg={2} key={34} >
                      <TextField
                        label="TOP RATIO"
                        type="number"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        error={(rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType === "2" && (rxOrder.colorRateTop === "" || rxOrder.colorRateTop === null || rxOrder.colorRateTop < 0 || rxOrder.colorRateTop > 100))}
                        helperText="درصد رنگ بالا"
                        InputProps={{ inputProps: { min : 0 , max : 100 , step : 10 } }}
                        size="small"
                        variant="standard"
                        fullWidth
                        onChange={handleColoingRateTopChange}
                        value={rxOrder.colorRateTop === null ? '' : rxOrder.colorRateTop}
                        disabled={!(rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType.toString() === "2")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={1} lg={2} key={35} >
                      <TextField
                        label="BOTTOM RATIO"
                        type="number"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        sx={{
                          //width: 135,
                          '.MuiInputBase-input': { fontSize: '13px' },
                        }}
                        error={(rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType === "2" && (rxOrder.colorRateBottom === "" || rxOrder.colorRateBottom === null || rxOrder.colorRateBottom < 0 || rxOrder.colorRateBottom > 100))}
                        helperText="درصد رنگ پایین"
                        InputProps={{ inputProps: { min : 0 , max : 100 , step : 10 } }}
                        size="small"
                        variant="standard"
                        fullWidth
                        onChange={handleColoingRateBottomChange}
                        value={rxOrder.colorRateBottom === null ? '' : rxOrder.colorRateBottom}
                        disabled={!(rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType === "2")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={5} lg={5} key={36} >
                    <Controller
                          name="extraServices"
                          render={({ field }) => (
                            <Autocomplete
                            multiple
                            id="extraServices"
                            options={rxOrder.ExtraServices.map(x => ({ id: x.Value, label: x.Name }))}
                            ////getOptionLabel={option => option}
                            renderOption={(props, option, state) => 
                              <div {...props} style={{ textAlign : "left" , direction : "ltr" }}>
                                {option.label}
                              </div>
                            }
                            //filterSelectedOptions
                            renderInput={params => (
                              <TextField
                                {...params}
                                //error={rxOrder.selectedColoringType !== null && rxOrder.selectedColoringType.length > 0 && (rxOrder.selectedColor === null || rxOrder.selectedColor === "")}
                                helperText="انتخاب خدمات"
                                variant="outlined"
                                label="EXTRA SERVICES"
                                placeholder=""
                                sx={{
                                  //width: 135,
                                  '.MuiInputBase-input': { fontSize: '13px' },
                                }}
                              />
                            )}
                            onChange={handleExtraServiceHandler}
                            value={rxOrder.selectedExtraServices}
                            size="small"
                            noOptionsText={<span className='noDataText'>اطلاعاتی یافت نشد</span>}
                            autoHighlight='true'
                            //disabled={!(rxOrder.selectedColoringType !== null)}
                          />
                          )}
                          control={control}
                          rules={{
                            validate: d => {
                              return d.length > 0;
                            }
                          }}
                        />
                     
                  </Grid>
                  </Grid>
                  </AccordionDetails>
                </Accordion>
                <Grid container 
                    spacing={{ xs: 1, md: 1 }} 
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                    >
           
                    <Grid item xs={12} sm={12} md={12} lg={12} key={38} >
                    <Stack direction="row"  divider={<Divider orientation="vertical" flexItem />} alignItems="center" spacing={1}>  
                  
   
                    <Box component="span" fullWidth sx={{ width: 1 , border: '1px solid grey'}}>

  
       <TextField
          type="text"
          label="توضیحات"
          InputLabelProps={{
            shrink: true,
          }}
          sx={{
            //width: 135,
            '.MuiInputBase-input': { fontSize: '13px' },
          }}
          helperText="توضیحات شما راجع به سفارش"
          fullWidth
          variant="standard"
          value={rxOrder.description}
          onChange={handleDescriptionChange}
        />
       
    </Box>

  
  </Stack>
                    </Grid>
          
                    </Grid>
                    <br/>
                    <hr/>
                    <br/>
                    <Grid container 
                    spacing={{ xs: 1, md: 1 }} 
                    columns={{ xs: 4, sm: 8, md: 12 }}
                    direction={{ xs: 'column', sm : 'row-reverse' , md: 'row-reverse' , lg : 'row-reverse'}}
                    >
                          <Grid item xs={12} sm={12} md={12} lg={12} key={39} >
                          <Box sx={{ flexGrow: 1 }} textAlign='center'>
                          <FormControl>
                        <FormLabel id="demo-row-radio-buttons-group-label">مشخصات عدسی قبلی</FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={rxOrder.oldLens === null ? '' : rxOrder.oldLens}
                          onChange={handleOldLensChange}
                        >
                          <FormControlLabel value="تکدید" control={<Radio />} label="تکدید" />
                          <FormControlLabel value="دودید" control={<Radio />} label="دودید" />
                          <FormControlLabel value="تدریجی" control={<Radio />} label="تدریجی" />
                        </RadioGroup>
                      </FormControl>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                        
                            <Tooltip title="ثبت سفارش با پیش نمایش ">
                            <Button className='mmgBtnSubmit'
                            sx={{ height: 100 }}
                            disabled={!IsRXOrderValidForPreview(rxOrder) || rxOrder.loading}
                            color="success" onClick={handleSubmitOrder} variant="outlined" startIcon={<BeenhereIcon />}>
                            ثبت سفارش با پیش نمایش 
                            </Button>
                            </Tooltip>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Tooltip title="ثبت سفارش مستقیم">
                            <Button  sx={{ height: 100 }} onClick={handleDirectSubmitOrder}  className='mmgBtnSubmit'
                            disabled={!IsRXOrderValidForPreview(rxOrder) || rxOrder.loading} variant="outlined" startIcon={<BeenhereIcon />}>
                                    ثبت سفارش مستقیم
                            </Button>
                            </Tooltip> 
                            {
                           authUser.username === "test" ?
                            <Tooltip title="ثبت سفارش پرداخت">
                            <Button  sx={{ height: 100 }} onClick={handleDirectSubmitOrderOnlinePayment}  className='mmgBtnSubmit'
                            disabled={!IsRXOrderValidForPreview(rxOrder) || rxOrder.loading} variant="outlined" startIcon={<BeenhereIcon />}>
                                    ثبت سفارش و پرداخت
                            </Button>
                            </Tooltip> : ""
                          }
                          
                        </Box>
                          </Grid>
                      </Grid>
     <RXPreviewItems />
            <Dialog
              open={rxOrder.boxType > 0}
              //onClose={handleCloseMessageBox}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
             >
              <DialogTitle id="alert-dialog-title">
                {"نتیجه عملیات"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <Alert severity={rxOrder.boxType === 1 ? "error" : (rxOrder.boxType === 2 ? "success" : "info")}>
                <Typography
                    variant="span"
                    color="primary"
                    dangerouslySetInnerHTML={{ __html: rxOrder.boxMessage }}>
                </Typography>
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {rxOrder.boxType === 2 ?   
                <Grid container justify='space-between' spacing={2}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <Button fullWidth variant="contained" color='success' onClick={handleCloseMessageBox}>
                سفارش جدید
              </Button>
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <Button fullWidth variant="contained" color='success' onClick={handleCloseMessageBoxAndGotoOrderList}>
                پیگیری سفارش
              </Button>
                </Grid>
            </Grid>
                : 
               
               <Button variant="contained" color='error' onClick={handleCloseMessageBox}>
                     خب
              </Button>
              }
              </DialogActions>
            </Dialog>
    </AccordionDetails>
    </Accordion>
    </Grid>
    </Grid>
    </Box>
    <Dialog
              open={open}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از ثبت نهایی سفارش اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYes}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNo}>
                خیر
              </Button>
            

              </DialogActions>
            </Dialog>

            {rxOrder.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }

    </ThemeProvider>
    </>
  );
}

export default RX;